import React from 'react';

import NotFoundApp from './components/not-found-app';
import WithQuery from '../../../../common/components/with-query';

const NotFound = props => {
  return (
    <WithQuery query={props.location.search}>
      <NotFoundApp />
    </WithQuery>
  );
}

export default NotFound;
